function name() {
  return {
    restrict: 'A',
    require: '?^^ogFormfield',
    link: function($scope, $element, $attrs, ogFormfield) {
      if (ogFormfield) {
        ogFormfield.fieldName = $attrs.name;
      }
    }
  };
}

name.$inject = [];

module.exports = name;
